import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import ConfigAccordionBase from '../Config/ConfigAccordionBase'
import { Text } from '../../1elements'
import ObjectTypeDropdown from './ObjectTypeDropdown'
import LayoutsTable from './LayoutsTable'
import { Button } from '@mui/material'
import { getLayoutObjectTypeLabel } from './layoutTerminology'

const useStyles = makeStyles({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: 20,
    maxWidth: '98%',
    '& > div > p': {
      marginBottom: 30,
    },
  },
  headerRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 20,
  },
  dropdownContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  },
  table: {
    maxHeight: 400,
    overflowY: 'auto',
  },
})

const LayoutTable = ({
  selectedObjectType,
  setSelectedObjectType,
  layouts,
  onRowSelect,
  onCreateNewLayout,
  onEditMode,
  onDeleteLayout,
}) => {
  const classes = useStyles()

  return (
    <ConfigAccordionBase className={classes.root} label={'Layouts'}>
      <div className={classes.headerRow}>
        <div className={classes.dropdownContainer}>
          <ObjectTypeDropdown
            selectedObjectType={selectedObjectType}
            setSelectedObjectType={setSelectedObjectType}
          />
        </div>
        <Button
          variant="contained"
          color="primary"
          onClick={onCreateNewLayout}
        >
          Create New Layout
        </Button>
      </div>

      <div className={classes.table}>
        <Text type={'h9'}>
          Layouts for {getLayoutObjectTypeLabel(selectedObjectType)}
        </Text>
        <LayoutsTable
          layouts={layouts}
          onRowSelect={onRowSelect}
          onEditMode={onEditMode}
          onDeleteLayout={onDeleteLayout}
        />
      </div>
    </ConfigAccordionBase>
  )
}

export default LayoutTable
